import * as React from "react";
import classNames from "classnames";
import Label from "./Label";

interface IProps {
	title?: {};
	name: string;
	radioOptions: IRadioInput[];
	onBlur?: (value: {}) => void;
	onChange?: (value: {}) => void;
	className?: string;
	children?: {};
	required?: boolean;
	disabled?: boolean;
	vertical?: boolean;
}

export interface IRadioInput {
	id: string;
	label: {};
	value: string;
	checked?: boolean;
	onBlur?: (value: {}) => void;
	onChange?: (value: {}) => void;
	className?: string;
	disabled?: boolean;
	conditionalChildren?: {};
}

const RadioGroup: React.FC<IProps> = (props) => {
	return (
		<div
			className={classNames(
				"form-group",
				props.className,
				{
					"form-group-required": props.required,
				},
				props.vertical && "flex-column"
			)}
			onBlur={props.onBlur}
			onChange={props.onChange}
		>
			{props.title && <Label required={props.required}>{props.title}</Label>}
			{props.radioOptions.map((radio) => (
				// TODO: Only include wrapper div if conditionalChildren exists
				<div
					className={classNames("form-check-wrapper", props.className)}
					key={radio.value}
				>
					<div
						className={classNames("form-check custom-control custom-radio", {
							// disabled: radio.disabled,
						})}
					>
						<input
							type="radio"
							name={props.name}
							value={radio.value}
							id={radio.id}
							checked={radio.checked}
							onBlur={radio.onBlur}
							onChange={radio.onChange}
							disabled={radio.disabled}
							className="form-check-input custom-control-input"
						/>
						<label
							className="form-check-label custom-control-label"
							htmlFor={radio.id}
						>
							{radio.label}
						</label>
					</div>
					{radio.conditionalChildren}
				</div>
			))}
			{props.children}
		</div>
	);
};

export default RadioGroup;
